module.exports = __webpack_public_path__ + "img/logo.78f9838d.png";